<template>
  <svg
    class="inline fill-current icon-base"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00134 0.25C3.72009 0.25 0.251343 3.71875 0.251343 8C0.251343 12.2812 3.72009 15.75 8.00134 15.75C12.2826 15.75 15.7513 12.2812 15.7513 8C15.7513 3.71875 12.2826 0.25 8.00134 0.25ZM8.00134 14.25C4.54822 14.25 1.75134 11.4531 1.75134 8C1.75134 4.54688 4.54822 1.75 8.00134 1.75C11.4545 1.75 14.2513 4.54688 14.2513 8C14.2513 11.4531 11.4545 14.25 8.00134 14.25ZM11.0013 5.5V10.5C11.0013 10.775 10.7763 11 10.5013 11H9.00134C8.72634 11 8.50134 10.775 8.50134 10.5V5.5C8.50134 5.225 8.72634 5 9.00134 5H10.5013C10.7763 5 11.0013 5.225 11.0013 5.5ZM7.50134 5.5V10.5C7.50134 10.775 7.27634 11 7.00134 11H5.50134C5.22634 11 5.00134 10.775 5.00134 10.5V5.5C5.00134 5.225 5.22634 5 5.50134 5H7.00134C7.27634 5 7.50134 5.225 7.50134 5.5Z"
    />
  </svg>
</template>
